import { gql } from '@apollo/client'

export const UPDATE_TASK_MUTATION = gql`
  mutation updateTask($id: ID!, $attributes: TaskInput!) {
    updateTask(id: $id, attributes: $attributes) {
      completedAt
      createdAt
      done
      dueDate
      id
      processingId
      title
      updatedAt
    }
  }
`
